import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

/**
 * Version en service, en pied de menu.
 *
 * Discrète mais toujours là : c'est la première chose qu'on demande quand un
 * écran ne se comporte pas comme prévu, et la dernière qu'on veut aller
 * chercher dans un fichier. Elle mène aux notes de version.
 */
export function VersionInstallee(): ReactElement | null {
  const version = useQuery({
    queryKey: ['version'],
    queryFn: () => api.version(),
    // Elle ne change qu'au deploiement : inutile de la redemander.
    staleTime: Infinity,
  });

  if (!version.data) return null;

  return (
    <Link className="version-installee" to="/notes-de-version">
      Version {version.data.version}
    </Link>
  );
}
